import { Col, Row } from 'antd';
import styles from './ProductIngredientInfo.module.scss';
// importing images
import { getNutriScoreImg } from '../../utils/helpers';
import Contactless from './images/contactless.svg';
import FreeDelivery from './images/freeDelivery.svg';
import GlutenFree from './images/gluten_free.svg';
import NonRefundable from './images/nonRefundable.svg';
import Refundable from './images/refundable.svg';
import Vegan from './images/vegan.svg';

const ProductIngredientInfo = ({ product }) => {
  return (
    <div className={styles.productIngredientInfo}>
      {/* <div className={styles.title}>Ingredients & Allergen information </div> */}

      {/* ingredient info */}
      <div className={styles.ingredientInfo}>
        <div className={styles.ingredientTitle}>Ingredients</div>
        <div className={styles.allergyAdvice}>
          Allergy Advice: For allergens see highlighted ingredients
        </div>
        <div className={styles.ingredientList}>{product.list_of_ingredients}</div>
      </div>

      {/* allergen info */}
      {/* <div className={styles.allergenInfo}>
        <div className={styles.allergenTitle}>Allergen Information</div>
        <div className={styles.allergenList}>
          <span style={{ fontWeight: '300' }}>May contain</span> {product.allegen_labelling}
        </div>
      </div> */}

      {/* additional info */}
      <div className={styles.additionalInfo}>
        <div className={styles.additionalTitle}>Allergen Information</div>
        <div className={styles.additionalListWrapper}>
          <div className={styles.allergenList}>
            <div style={{ fontWeight: '300', marginBottom: 10 }}>
              May contain allergen labelling
            </div>
          </div>
          <Row gutter={[25, 25]}>
            {product.is_gluten_free && (
              <Col lg={4} xs={8}>
                <div className={styles.productDescription_features_content}>
                  <img src={GlutenFree} alt={'gluten free'} />
                  <div>Gluten Free</div>
                </div>
              </Col>
            )}
            {product.is_vegan && (
              <Col lg={4} xs={8}>
                <div className={styles.productDescription_features_content}>
                  <img src={Vegan} alt={'gluten free'} />
                  <div>Vegan</div>
                </div>
              </Col>
            )}
            {product.is_refundable && (
              <Col lg={4} xs={8}>
                <div className={styles.productDescription_features_content}>
                  <img src={Refundable} alt={'gluten free'} />
                  <div>Refundable</div>
                </div>
              </Col>
            )}
            {product.has_free_delivery && (
              <Col lg={4} xs={8}>
                <div className={styles.productDescription_features_content}>
                  <img src={FreeDelivery} alt={'gluten free'} />
                  <div>Free Delivery</div>
                </div>
              </Col>
            )}
            {product.is_non_refundable && (
              <Col lg={4} xs={8}>
                <div className={styles.productDescription_features_content}>
                  <img src={NonRefundable} alt={'gluten free'} />
                  <div>Non Refundable</div>
                </div>
              </Col>
            )}
            {product.has_contactless_delivery && (
              <Col lg={4} xs={8}>
                <div className={styles.productDescription_features_content}>
                  <img src={Contactless} alt={'gluten free'} />
                  <div>Contactless Delivery</div>
                </div>
              </Col>
            )}
          </Row>
        </div>
      </div>

      {/* nutri score */}
      <div className={styles.nutriScoreInfo}>
        <div className={styles.nutriScoreTitle}>Nutrition Score</div>
        <img
          style={{ height: 60 }}
          src={getNutriScoreImg(product.nutri_score)}
          alt={product.nutri_score}
        />
        <div style={{ color: '#444444', marginTop: 15 }}>
          The nutriscore has been calculated on the basis of nutritional information and is not a
          binding on the seller. Interested to know more about{' '}
          <span style={{ textDecorationLine: 'underline' }}>nutriscore?</span>
        </div>
      </div>

      {/* storage instruction */}
      <div className={styles.storageInfo}>
        <div className={styles.storageTitle}>Storage Instructions</div>
        <div style={{ color: '#444444' }}>
          The product shall be preferably stored in dark at room temperature.
        </div>
      </div>
    </div>
  );
};

export default ProductIngredientInfo;
